export interface ContentReport {
  id: string;
  reportedBy: {
    userId: string;
    userName: string;
  };
  contentType: 'challenge_result';
  contentId: {
    challengeId: string;
    participantId: string;
  };
  reason: 'inappropriate' | 'spam' | 'offensive' | 'copyright' | 'other';
  description: string;
  status: 'pending' | 'reviewed' | 'resolved' | 'dismissed';
  createdAt: Date;
  reviewedAt?: Date;
  reviewedBy?: {
    userId: string;
    userName: string;
  };
  action?: 'hidden' | 'deleted' | 'no_action';
  adminNotes?: string;
}

export interface ReportReason {
  value: ContentReport['reason'];
  label: string;
  description: string;
}

export const REPORT_REASONS: ReportReason[] = [
  {
    value: 'inappropriate',
    label: 'Inappropriate Content',
    description: 'Content that is not suitable for this community'
  },
  {
    value: 'spam',
    label: 'Spam',
    description: 'Irrelevant or repetitive content'
  },
  {
    value: 'offensive',
    label: 'Offensive',
    description: 'Content that is offensive or hateful'
  },
  {
    value: 'copyright',
    label: 'Copyright Violation',
    description: 'Content that violates copyright'
  },
  {
    value: 'other',
    label: 'Other',
    description: 'Other reason not listed above'
  }
];
